/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  ActiveCheckoutPaymentDto,
  CheckoutConfigDto,
  CheckoutPaymentDto,
  CheckoutPaymentIntentDto,
  CreateCheckoutPaymentIntentRequest,
  GetMeCheckoutConfigV1Params
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getMeCheckoutConfigV1Response200 = {
  data: CheckoutConfigDto
  status: 200
}

export type getMeCheckoutConfigV1Response400 = {
  data: void
  status: 400
}

export type getMeCheckoutConfigV1Response401 = {
  data: void
  status: 401
}

export type getMeCheckoutConfigV1Response502 = {
  data: void
  status: 502
}

export type getMeCheckoutConfigV1ResponseSuccess = (getMeCheckoutConfigV1Response200) & {
  headers: Headers;
};
export type getMeCheckoutConfigV1ResponseError = (getMeCheckoutConfigV1Response400 | getMeCheckoutConfigV1Response401 | getMeCheckoutConfigV1Response502) & {
  headers: Headers;
};

export type getMeCheckoutConfigV1Response = (getMeCheckoutConfigV1ResponseSuccess | getMeCheckoutConfigV1ResponseError)

export const getGetMeCheckoutConfigV1Url = (params: GetMeCheckoutConfigV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/checkout/config?${stringifiedParams}` : `/api/v1/me/checkout/config`
}

/**
 * What the payment screen needs before anything is charged: the publishable key to boot
 * Stripe.js with, and which payment methods to offer.
 *
 * Read-only and side-effect free — the card fields are Stripe-hosted iframes that must
 * be mounted as soon as the customer picks "credit card", long before they press pay.
 *
 * Boot Stripe.js with THIS key. A client secret only confirms against the account it
 * belongs to, so re-keying after the intent means re-mounting the card fields and
 * losing whatever the customer already typed.
 *
 * contextReference is optional and today only matters for bookings, whose account can
 * come from the service being booked; shop and events resolve from the context alone.
 * @summary Keys and methods for the payment screen
 */
export const getMeCheckoutConfigV1 = async (params: GetMeCheckoutConfigV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getMeCheckoutConfigV1Response> => {

  return customFetch<getMeCheckoutConfigV1Response>(getGetMeCheckoutConfigV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type createMeCheckoutPaymentIntentV1Response200 = {
  data: CheckoutPaymentIntentDto
  status: 200
}

export type createMeCheckoutPaymentIntentV1Response400 = {
  data: void
  status: 400
}

export type createMeCheckoutPaymentIntentV1Response401 = {
  data: void
  status: 401
}

export type createMeCheckoutPaymentIntentV1Response404 = {
  data: void
  status: 404
}

export type createMeCheckoutPaymentIntentV1Response409 = {
  data: void
  status: 409
}

export type createMeCheckoutPaymentIntentV1Response422 = {
  data: void
  status: 422
}

export type createMeCheckoutPaymentIntentV1Response502 = {
  data: void
  status: 502
}

export type createMeCheckoutPaymentIntentV1Response503 = {
  data: void
  status: 503
}

export type createMeCheckoutPaymentIntentV1ResponseSuccess = (createMeCheckoutPaymentIntentV1Response200) & {
  headers: Headers;
};
export type createMeCheckoutPaymentIntentV1ResponseError = (createMeCheckoutPaymentIntentV1Response400 | createMeCheckoutPaymentIntentV1Response401 | createMeCheckoutPaymentIntentV1Response404 | createMeCheckoutPaymentIntentV1Response409 | createMeCheckoutPaymentIntentV1Response422 | createMeCheckoutPaymentIntentV1Response502 | createMeCheckoutPaymentIntentV1Response503) & {
  headers: Headers;
};

export type createMeCheckoutPaymentIntentV1Response = (createMeCheckoutPaymentIntentV1ResponseSuccess | createMeCheckoutPaymentIntentV1ResponseError)

export const getCreateMeCheckoutPaymentIntentV1Url = () => {




  return `/api/v1/me/checkout/payment-intents`
}

/**
 * Creates a Stripe PaymentIntent for what the customer is buying and returns the client
 * secret to confirm it with.
 *
 * The amount and the Stripe account are resolved server-side from context +
 * contextReference — the client never sends a money value and never chooses the
 * merchant. A reference belonging to another customer is a 404.
 *
 * Initialise Stripe.js with the publishableKey from THIS response: the client secret is
 * scoped to the account being charged and will not confirm with a different key.
 *
 * Confirming does not complete the purchase. Stripe's webhook does. Poll
 * GET /me/checkout/payments/{paymentId} afterwards, the same way for every method.
 *
 * Events: the seats are read from Salesforce at this moment, never from our copy.
 * Read failed → 503 event_availability_unavailable, nothing charged (retry later).
 * Status other than Published/Full as Salesforce reads it now (cancelled, completed,
 * back to draft) → 422 event_not_for_sale. Party − 1 over the guest limit (it counts
 * companions) → 400. Status Full or not enough seats → 409 event_sold_out with
 * availableSpots in the body, so the app can offer fewer guests — Full counts in any
 * booking mode. eventBooking.numberOfGuests is the whole party, member included.
 * The request itself is refused the way the register refuses it: no occurrenceId on a
 * multi-date event → 400 occurrence_required; an occurrenceId that is not this
 * event's → 404 occurrence_not_found; a booking that lives in another channel
 * (SevenRooms, Concierge, External) → 422 flow_mismatch.
 *
 * Requires the Idempotency-Key header.
 * @summary Start a payment
 */
export const createMeCheckoutPaymentIntentV1 = async (createCheckoutPaymentIntentRequest: CreateCheckoutPaymentIntentRequest, options?: Parameters<typeof customFetch>[1]): Promise<createMeCheckoutPaymentIntentV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createMeCheckoutPaymentIntentV1Response>(getCreateMeCheckoutPaymentIntentV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCheckoutPaymentIntentRequest)
  }
);}


export type getMeCheckoutPaymentV1Response200 = {
  data: CheckoutPaymentDto
  status: 200
}

export type getMeCheckoutPaymentV1Response401 = {
  data: void
  status: 401
}

export type getMeCheckoutPaymentV1Response404 = {
  data: void
  status: 404
}

export type getMeCheckoutPaymentV1ResponseSuccess = (getMeCheckoutPaymentV1Response200) & {
  headers: Headers;
};
export type getMeCheckoutPaymentV1ResponseError = (getMeCheckoutPaymentV1Response401 | getMeCheckoutPaymentV1Response404) & {
  headers: Headers;
};

export type getMeCheckoutPaymentV1Response = (getMeCheckoutPaymentV1ResponseSuccess | getMeCheckoutPaymentV1ResponseError)

export const getGetMeCheckoutPaymentV1Url = (paymentId: string,) => {




  return `/api/v1/me/checkout/payments/${paymentId}`
}

/**
 * Current state of a payment. Poll this after confirming until the status is terminal;
 * on success it carries the resulting order id and order number.
 * @summary Payment status
 */
export const getMeCheckoutPaymentV1 = async (paymentId: string, options?: Parameters<typeof customFetch>[1]): Promise<getMeCheckoutPaymentV1Response> => {

  return customFetch<getMeCheckoutPaymentV1Response>(getGetMeCheckoutPaymentV1Url(paymentId),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMeCheckoutActivePaymentsV1Response200 = {
  data: ActiveCheckoutPaymentDto[]
  status: 200
}

export type getMeCheckoutActivePaymentsV1Response401 = {
  data: void
  status: 401
}

export type getMeCheckoutActivePaymentsV1ResponseSuccess = (getMeCheckoutActivePaymentsV1Response200) & {
  headers: Headers;
};
export type getMeCheckoutActivePaymentsV1ResponseError = (getMeCheckoutActivePaymentsV1Response401) & {
  headers: Headers;
};

export type getMeCheckoutActivePaymentsV1Response = (getMeCheckoutActivePaymentsV1ResponseSuccess | getMeCheckoutActivePaymentsV1ResponseError)

export const getGetMeCheckoutActivePaymentsV1Url = () => {




  return `/api/v1/me/checkout/payments/active`
}

/**
 * Payments that have not reached a final state, with the client secret to resume them.
 *
 * This is the recovery path for asynchronous methods: with MB WAY the customer leaves
 * the app to approve on their phone and may return to a cold start with no payment id
 * in memory. Without this they would be stuck, because only one payment can be in
 * flight per purchase.
 * @summary Payments still in flight
 */
export const getMeCheckoutActivePaymentsV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getMeCheckoutActivePaymentsV1Response> => {

  return customFetch<getMeCheckoutActivePaymentsV1Response>(getGetMeCheckoutActivePaymentsV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


